
const PatchHardBreakOnInline = (opts = {}) => ({
  onKeyDown(event, data, change) {
    if (data.key !== 'enter') { return; }
    if (data.isShift) {
      // Soft tab seems fine.
      return;
    }

    if (change.state.inlines.size === 0) {
      return;
    }

    // There a couple of weird things happening
    // when hard breaking on the edges of
    // inline, so fix that..
    const { isExpanded, selection: sel, startInline, } = change.state;
    if (isExpanded) {
      // When hard breaking with selection starting from start of
      // inline and at least covering the end of it result in:
      // "Could not find a descendant node with key" error.
      // Direction of selection doesn't seem to matter.

      if (!startInline) {
        // Inline not at start of selection,
        // nothing special to do here. Noop.
        return;
      }

      // By here we know inline exists at startOffset.
      // Now check if startOffset is also at the start of inline.
      if (!sel.hasStartAtStartOf(startInline)) {
        // Basically startOffset somewhere after the start
        // of inline. Nothing special to do here. Noop.
        return;
      }

      // So we know selection starts at the start of inline.
      // Nwo check if selection spans beyond this inline, because
      // that's when it behaves oddly.
      if (sel.hasEndIn(startInline)) {
        return;
      }

      // Ok, we can now patch the expected behavior, which should be
      // to splitBlock. But before that, delete the selection first
      // to address the weirdness.
      // (Core plugin also checks if hasVoidParent before splitBlock,
      // but not applicable here since we know inline exists..)
      return change.delete().splitBlock();

    } else {
      // When hard breaking on the inside edge of inline endOffset,
      // weird behavior happens where cursor remains after splitBlock.

      if (sel.hasStartAtEndOf(startInline)) {
        // This is where odd shit happens, like cursor stays
        // at the end of inline after split. o_O

        // So move the selection to next block for slate..
        return change.splitBlock().collapseToStartOfNextBlock();
      }

      return; // Noop.
    }
  }
});


export default PatchHardBreakOnInline;



// WEBPACK FOOTER //
// ./src/components/slate/plugins/PatchHardBreakOnInline.js